//
//
//
//
//
//
//
//
//
//
//

import IndexPart from './share/index/index'

import { QR_IMG, OTHER_TOOLS } from './config'

export default {
    data() {
        return {
            qr_img: QR_IMG,
            other_tools: OTHER_TOOLS
        }
    },
    components: {
        IndexPart
    }
}
